"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Settings;

var _Settings = require("@adobe/react-spectrum-workflow/dist/Settings");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Settings(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Settings.A4uSettings, null));
}